export const categoryConstants = {
  ACCOUNTS: "Accounts",
  JOBS: "Jobs",
  CANDIDATES: "Candidates",
  USER: "User",
  JOBTIMELINE: "JobTimeline",
  TOS: "TOS",
};
